(() => {
  angular
    .module('gm.common.directives')
    .directive('gmPdfButton', gmPdfButtonDirective);

  function gmPdfButtonDirective(
    $window,
    $document
  ) {
    'ngInject';

    function exportPdf(target, attrs) {
      const doc = new $window.jsPDF();

      doc.addHTML(target, () => {
        doc.save(attrs.filename);
      });
    }

    return {
      restrict: 'E',
      scope: {
        text: '=?'
      },
      templateUrl: 'modules/common/directives/pdf-button/pdf-button.html',
      transclude: true,

      link(scope, element, attrs) {
        const target = attrs.element
          ? $document[0].getElementById(attrs.element)
          : $document[0].body;

        element.on('click', () => {
          if (attrs.load) {
            scope.$parent.$eval(attrs.load, {
              callback: exportPdf
            });
          } else {
            exportPdf(target, attrs);
          }
        });
      },
    };
  }
})();
